import SectionHeading from "@/components/base/SectionHeading";
import { overviewCards } from "@/mocks/highlights";

const updates = [
  "《九号病房》更新了 2 位主创的花絮",
  "车瑞妍 · 徐河准 绯闻新增一条媒体报道",
  "《四季食堂》特别篇确认原班回归",
  "《黄金帝国》收视较上周上升 0.6%",
  "《济州岛的雪》补录了配角演员表",
  "《汉江以北》幕后雨戏花絮已上线",
];

export default function QuickOverview() {
  return (
    <section className="relative w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8">
        {/* today update strip */}
        <div className="reveal mb-12 rounded-2xl border border-background-200 bg-background-100 overflow-hidden">
          <div className="flex items-center">
            <div className="flex items-center gap-2 px-4 md:px-6 py-3.5 bg-primary-500 text-background-50 shrink-0">
              <i className="ri-broadcast-line"></i>
              <span className="text-sm font-label font-medium whitespace-nowrap">今日更新</span>
            </div>
            <div className="relative flex-1 overflow-hidden">
              <div className="marquee-track flex w-max items-center gap-8 px-6 py-3.5">
                {[...updates, ...updates].map((text, i) => (
                  <span
                    key={`${text}-${i}`}
                    className="text-sm text-foreground-600 whitespace-nowrap flex items-center gap-2"
                  >
                    <i className="ri-checkbox-blank-circle-fill text-[6px] text-accent-500"></i>
                    {text}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        <SectionHeading
          eyebrow="站内速览"
          title="一页之内，你能找到什么"
          desc="不用来回跳转，从剧集演员表到戏外动态，四个分区就把追剧想知道的信息补齐。往下滚动，每一块都有具体内容可看。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {overviewCards.map((card, i) => (
            <article
              key={card.title}
              className="reveal group rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6 hover:border-primary-300 transition-colors"
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <span className="w-12 h-12 rounded-xl bg-primary-50 text-primary-600 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${card.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading font-semibold text-lg text-foreground-950">
                {card.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{card.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-label text-primary-600">
                继续往下看
                <i className="ri-arrow-down-line"></i>
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}